import { useState } from "react";
import { useSiteContent } from "@/context/SiteContentContext";
import { Plus, X, Wrench } from "lucide-react";

// "Add service" — paid services (Admin → Invoice → Shërbime me pagesë), independent of products
export default function ServiceLinesEditor({ lines, onChange, testIdPrefix = "sales-svc" }) {
    const { content } = useSiteContent();
    const options = content.invoice_paid_services || [];
    const prices = content.invoice_service_prices || {};
    const [custom, setCustom] = useState("");

    const add = (name) => {
        const n = (name || "").trim();
        if (!n) return;
        const i = lines.findIndex((l) => l.name === n);
        if (i >= 0) return onChange(lines.map((l, k) => (k === i ? { ...l, qty: (parseInt(l.qty, 10) || 0) + 1 } : l)));
        onChange([...lines, { name: n, qty: 1, price_lek: prices[n] || 0 }]);
    };
    const update = (i, patch) => onChange(lines.map((l, k) => (k === i ? { ...l, ...patch } : l)));

    return (
        <div data-testid={`${testIdPrefix}-editor`}>
            <label className="label-kicker mb-1 block">Add service</label>
            <div className="flex flex-wrap gap-2">
                <select value="" onChange={(e) => add(e.target.value)} className="input-field flex-1 min-w-[200px]" data-testid={`${testIdPrefix}-select`}>
                    <option value="">— Zgjidh shërbimin —</option>
                    {options.map((o) => (
                        <option key={o} value={o}>{o}{prices[o] ? ` — ${Number(prices[o]).toLocaleString()} Lek` : ""}</option>
                    ))}
                </select>
                <input value={custom} onChange={(e) => setCustom(e.target.value)} onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), add(custom), setCustom(""))} placeholder="ose shkruaj shërbim tjetër" className="input-field !w-48 !text-xs" data-testid={`${testIdPrefix}-custom-input`} />
                <button type="button" onClick={() => { add(custom); setCustom(""); }} className="btn-outline !py-1.5 !text-xs" data-testid={`${testIdPrefix}-custom-add`}><Plus className="w-3.5 h-3.5" /> Shto</button>
            </div>
            {lines.length > 0 && (
                <div className="border border-slate-200 mt-2" data-testid={`${testIdPrefix}-lines`}>
                    {lines.map((l, i) => (
                        <div key={i} className="flex items-center gap-2 px-2 py-1.5 border-b border-slate-100 text-xs" data-testid={`${testIdPrefix}-line-${i}`}>
                            <Wrench className="w-3.5 h-3.5 text-slate-400 shrink-0" />
                            <span className="flex-1 font-bold">{l.name}</span>
                            <input type="number" min="1" value={l.qty} onChange={(e) => update(i, { qty: e.target.value })} className="input-field !py-1 !px-2 !text-xs !w-16" data-testid={`${testIdPrefix}-qty-${i}`} />
                            <span className="text-slate-400">×</span>
                            <input type="number" min="0" step="50" value={l.price_lek} onChange={(e) => update(i, { price_lek: e.target.value })} className="input-field !py-1 !px-2 !text-xs !w-24 text-right" data-testid={`${testIdPrefix}-price-${i}`} />
                            <span className="font-mono text-[10px] text-slate-500 w-24 text-right">{Math.round((parseFloat(l.price_lek) || 0) * (parseInt(l.qty, 10) || 0)).toLocaleString()} Lek</span>
                            <button type="button" onClick={() => onChange(lines.filter((_, k) => k !== i))} className="text-red-600" data-testid={`${testIdPrefix}-remove-${i}`}><X className="w-4 h-4" /></button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export const serviceLinesPayload = (lines) =>
    lines.filter((l) => (l.name || "").trim()).map((l) => ({ name: l.name.trim(), qty: Math.max(1, parseInt(l.qty, 10) || 1), price_lek: Math.max(0, parseFloat(l.price_lek) || 0) }));
